import colors from '@colors'
import {Select, SelectProps, Stack, styled} from '@mui/material'
import {CommonProps} from '@mui/material/OverridableComponent'

export const StyledSelect = styled(Select, {
  shouldForwardProp: prop => prop !== 'hideBorder' && prop !== 'customStyle',
})<SelectProps & {hideBorder?: boolean; customStyle?: CommonProps['style']}>(({theme, hideBorder, customStyle}) => ({
  ...customStyle,
  ...(hideBorder && {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.common.white,
    },
  }),
  '&& .MuiSelect-select.MuiOutlinedInput-input': {
    paddingRight: 4,
  },
}))

export const MenuItemContent = styled(Stack)(() => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
}))

export const iconStyle = {
  color: colors.gray[2],
  paddingRight: 10,
}
